export default __webpack_public_path__ + "static/illustration-content-title.url-b0cfaceb444d162765bf8be6a1672d4d.svg";